import i18n from 'i18next'

import { BasicViewPaths, SubscriptionSteps } from '../../common/types.js'
import { changeLocale } from '../i18n.js'
import { PortalViewPaths, Route, SubscriptionUuidViewPaths } from '../types.js'

const getStep = (notCheckedStep: string) => {
    const possibleSteps = ['plan', 'auth', 'personal', 'sign', 'credit-check', 'validation']
    if (possibleSteps.includes(notCheckedStep)) {
        return notCheckedStep as SubscriptionSteps
    }

    return SubscriptionSteps.PLANS
}

export const parseRoute = (rawRoute: string): Route => {
    const parts = rawRoute.split('/')
    const [view, subscriptionUuid, step] = parts
    const validatedStep = getStep(step)

    switch (view) {
        case SubscriptionUuidViewPaths.SUBSCRIPTION_EXISTS:
        case SubscriptionUuidViewPaths.SUBSCRIPTION:
            switch (step) {
                case BasicViewPaths.GENERAL_ERROR:
                case BasicViewPaths.CREDIT_FAILED:
                case BasicViewPaths.AUTH_ERROR:
                case BasicViewPaths.ACCESSORY_ERROR:
                    return { type: 'basic', view: step, subscriptionUuid }

                default:
                    return {
                        type: 'basic',
                        view,
                        subscriptionUuid,
                        step: validatedStep,
                    }
            }

        // DEMO routes
        case BasicViewPaths.AUTH_ERROR:
        case BasicViewPaths.SIGN_SUCCESS:
        case BasicViewPaths.SIGN_REJECT:
        case BasicViewPaths.CREDIT_FAILED:
        case BasicViewPaths.GENERAL_ERROR: {
            return { type: 'basic', view }
        }

        // Portal routes
        case PortalViewPaths.DASHBOARD:
        case PortalViewPaths.OFFERS:
        case PortalViewPaths.UPGRADE:
        case PortalViewPaths.INVOICES:
        case PortalViewPaths.FAQ:
            return { type: 'portal', view }

        case PortalViewPaths.ACCOUNT:
            return { type: 'portal', view, accountView: parts[1] === 'billing' ? 'billing' : 'contact' }

        case PortalViewPaths.MY_SUBSCRIPTIONS:
        case PortalViewPaths.MY_PREVIOUS_DEVICES:
            return { type: 'portal', view, subscriptionUuid, step, parts }

        // Portal language specific routes login routes
        case PortalViewPaths.FI:
        case PortalViewPaths.DA:
        case PortalViewPaths.SV:
        case PortalViewPaths.NB:
        case PortalViewPaths.NO:
            if ((i18n as unknown as { language: string }).language !== view) {
                void changeLocale(view === 'no' ? 'nb' : view)
            }

            switch (subscriptionUuid) {
                case BasicViewPaths.PRIVACY_POLICY:
                    return { type: 'basic', view: BasicViewPaths.PRIVACY_POLICY }

                default:
                    return { type: 'portal', view: PortalViewPaths.LOGIN }
            }

        case PortalViewPaths.DEBUG:
            return { type: 'portal', view: PortalViewPaths.DEBUG }

        default:
            return { type: 'portal', view: PortalViewPaths.LANGUAGE_SELECT }
    }
}
